import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";
import classes from "./ToastStyles.module.scss";
import erroricon from "../../Components/assets/Images/errorIcon.svg";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

interface props {
  message: any;
}

export default function ErrorSnackBar({ message }: props) {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message.length > 1) {
      setOpen(true);
      setTransition(() => TransitionUp);
    }
    if (message.length === 0) {
      setOpen(false);
      setTransition(() => TransitionUp);
    }
  }, [message]);

  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={transition}
        sx={{ margin: "50px auto", width: "max-content", zIndex: 99 }}
      >
        <div
          className={`${classes.wrapper2} animate__animated animate__fadeInRight`}
        >
          <img src={erroricon} alt="" />
          <div className={classes.content}>
            {/* <div className={classes.text1}>Rejected</div> */}
            <div className={classes.text2}>{message}</div>
          </div>
        </div>
        {/* <div style={{ background: "tansparent", borderRadius: "10px " }}>
          <div>
            <Alert
              icon={false}
              severity="success"
              sx={{
                width: "max-content",
                height: "max-content",
                fontSize: "14px",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                background: "#F9E7E7",
                padding: "0 10px !important",
                fontFamily: "inherit",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={errorimage} style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "14px",
                    color: "#EA3535",
                  }}
                >
                  {message}
                </p>
              </div>
            </Alert>
          </div>
        </div> */}
      </Snackbar>
    </div>
  );
}
